export default "__VITE_ASSET__D1J9SuG$__"